import { useMemo } from "react";

const usePermissions = (
  backendPermissions?: Partial<Permissions>
) => {
  return useMemo(
    () => mapPermissions(backendPermissions),
    [backendPermissions]
  );
};

export default usePermissions;

export const mapPermissions = (
  backendPermissions?: Partial<Permissions>
): Permissions => ({
  ...defaultPermissions,
  ...backendPermissions,
});

export const defaultPermissions: Permissions = {
  edit: false,
  delete: false,
  create: false,
  view: false,
  assign: false,
  archive: false,
};

export type PermissionKey =
  | "edit"
  | "delete"
  | "create"
  | "view"
  | "assign"
  | "archive";

export type Permissions = Record<PermissionKey, boolean>;
